export const TRADITIONAL = 'HAG';
export const PAPERLESS = 'PAP';
export const HYBRID = 'HYB';
export const DEALER_TRADITIONAL = 'DLR_HAG';
export const DEALER_PAPERLESS = 'DLR_PAP';

export const tariffTypeNameMap = {
    [TRADITIONAL]: 'hagyományos',
    [PAPERLESS]: 'papírmentes',
    [HYBRID]: 'hibrid',
    [DEALER_TRADITIONAL]: 'dealer hagyományos',
    [DEALER_PAPERLESS]: 'dealer papírmentes',
};
